import {
  NEW_NGUOI_DUNG_SUCCESS,
  NEW_NGUOI_DUNG_FAIL,
  DELETE_NGUOI_DUNG_SUCCESS,
  DELETE_NGUOI_DUNG_FAIL,
  NEW_USER_SERVER_IS_SUCCESS,
  NEW_USER_SERVER_IS_FAIL,
  CHANGE_LOADING_STATE
} from 'src/constants/ActionTypes';
import Helper from 'src/helpers';
import { messages } from 'src/constants/messages';
import MessageStatus from 'src/util/MessageStatus';

let initialState = {
  refresh: false,
  setEmpty: false,
  data: [],
  hasError: false,
  status: 200
};
const nguoiDungReducer = (state = initialState, action) => {
  switch (action.type) {
    case NEW_NGUOI_DUNG_SUCCESS:
      const responseStatus = action.status;
      if (responseStatus === 200 || responseStatus === 201) {
        Helper.alertSuccessMessage(messages.THEM_THANH_CONG);
        state.data = action.data;
        state.message = messages.THEM_THANH_CONG
        return { ...state, error: '', loading: false };
      } else {
        MessageStatus(responseStatus);
        return { ...state };
      }
    case NEW_NGUOI_DUNG_FAIL:
      return { ...state, error: action.payload, message: '', loading: false };
    case DELETE_NGUOI_DUNG_SUCCESS:
      Helper.alertSuccessMessage(messages.XOA_THANH_CONG);
      return { ...state, error: '', message: '', loading: true };
    case DELETE_NGUOI_DUNG_FAIL:
      return { ...state, error: action.payload, message: '', loading: false };
    case CHANGE_LOADING_STATE:
      return { ...state, error: '', message: '', loading: action.payload.loading };
    default:
      return state;
  }
};

const newUserServerReducer = (state = initialState, action) => {
  switch (action.type) {
    case NEW_USER_SERVER_IS_SUCCESS:
      Helper.alertSuccessMessage(messages.THEM_THANH_CONG);
      return {...state, action, message: messages.THEM_THANH_CONG};
    case NEW_USER_SERVER_IS_FAIL:
      Helper.alertError(messages.TRUNG_DU_LIEU);
      return state;
    default:
      return state;
  }
};

export {
  nguoiDungReducer,
  newUserServerReducer
};